import '../../../../../../../app/assets/javascripts/pages/groups/show/index.js?vue3';
import initGroupAnalytics from '../../../analytics/group_analytics/group_analytics_bundle.js?vue3';
import { shouldQrtlyReconciliationMount } from '../../../billings/qrtly_reconciliation/index.js?vue3';
import initVueAlerts from '../../../../../../../app/assets/javascripts/vue_alerts.js?vue3';
import initTierBadgeTrigger from '../../../groups/init_tier_badge_trigger.js?vue3';

initGroupAnalytics();
initVueAlerts();
shouldQrtlyReconciliationMount();
initTierBadgeTrigger();
